import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import {
  generateRFPFeedback,
  updateFeedbackData,
} from 'src/redux/async/rfxManagement/rfpManagementAsync'

const initialState = {
  generate_feedback_payload: {},
  generate_feedback_loader: false,
  generated_feedback_details: {},
  generate_feedback_error: '',
  transformedData: [],
  skuHeaderKeys: {},
  updateFeedbackLoader: false,
}

export const generateFeedbackSlice = createSlice({
  name: 'generated-feedback-details',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(generateRFPFeedback.pending), (state) => {
      state.generate_feedback_loader = true
    })
    builder.addMatcher(isAnyOf(generateRFPFeedback.fulfilled), (state, action) => {
      state.generate_feedback_loader = false
      state.generated_feedback_details = action.payload.data
    })
    builder.addMatcher(isAnyOf(generateRFPFeedback.rejected), (state, action) => {
      state.generate_feedback_loader = false
      state.generate_feedback_error = action.payload.message
    })
    builder.addMatcher(isAnyOf(updateFeedbackData.pending), (state) => {
      state.updateFeedbackLoader = true
    })
    builder.addMatcher(isAnyOf(updateFeedbackData.rejected), (state) => {
      state.updateFeedbackLoader = false
    })
    // builder.addMatcher(isAnyOf(updateFeedbackData.fulfilled), (state) => {
    //   state.updateFeedbackLoader = false
    // })
  },
  reducers: {
    // Set data to initial state
    resetFeedbackData: () => {
      return initialState
    },
    setFeedbackPayloadData: (state, action) => {
      state.generate_feedback_payload = action.payload
    },
    setTransformedData: (state, action) => {
      state.transformedData = action.payload
    },
    setSkuHeaderKeys: (state, action) => {
      state.skuHeaderKeys = action.payload
    },
    setUpdateFeedbackDataLoader: (state, action) => {
      state.updateFeedbackLoader = action.payload
    },
  },
})

export const {
  resetFeedbackData,
  setFeedbackPayloadData,
  setTransformedData,
  setSkuHeaderKeys,
  setUpdateFeedbackDataLoader,
} = generateFeedbackSlice.actions

export default generateFeedbackSlice.reducer
